import { StorageKeys } from '@/lib/storage/keys'

export const AGENT_PANEL_VISIBILITY_EVENT = 'flownotes-agent-panel-visibility'

export type AgentPanelVisibilityDetail = {
  visible: boolean
}

function readBool(key: string, fallback: boolean): boolean {
  if (typeof localStorage === 'undefined') return fallback
  try {
    const raw = localStorage.getItem(key)
    if (raw == null) return fallback
    const parsed = JSON.parse(raw) as { value?: unknown; _version?: number } | boolean
    if (typeof parsed === 'boolean') return parsed
    // usePersistedState shape: { _version, value }
    if (parsed && typeof parsed === 'object' && typeof parsed.value === 'boolean') {
      return parsed.value
    }
    if (raw === 'true') return true
    if (raw === 'false') return false
  } catch {
    // ignore
  }
  return fallback
}

/** Best-effort read from persisted layout keys (usePersistedState shape). */
export function getAgentPanelVisibleFromStorage(): boolean {
  const showAgent = readBool(StorageKeys.UI_SHOW_AGENT, true)
  const agentCollapsed = readBool(StorageKeys.UI_AGENT_COLLAPSED, false)
  return showAgent && !agentCollapsed
}

export function dispatchAgentPanelVisibility(visible: boolean): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent(AGENT_PANEL_VISIBILITY_EVENT, {
      detail: { visible } satisfies AgentPanelVisibilityDetail,
    })
  )
}
